import { FamilyNewsletterOptionsEnum, familyNewsletterOptions } from "@/consts/newsletter";

type FacilityWithNewsletterOptions = {
  familyNewsletterOptions?: Array<{ name: string; status: boolean }>;
};

export const disableFamilyNewsletterOption = (facility: FacilityWithNewsletterOptions, optionName: FamilyNewsletterOptionsEnum) => {
  const options = facility.familyNewsletterOptions || familyNewsletterOptions.map(option => ({ ...option }));
  const option = options.find(item => item.name === optionName);

  if (option) option.status = false;
  facility.familyNewsletterOptions = options;
};